export default __webpack_public_path__ + "static/media/banner_logo.8f2291b2.svg";